// A nudge's words cut into plain text and the tasks it names, so each task can be a link (Craig, 25 Oct 2026: "turn
// tasks into hyperlinks to them"). Nudges quote task names ("Book the flights"). One that names a single task also
// stores its id; one that lists several ("You have 3 overdue tasks: …") stores none, so the names are matched against
// the user's tasks. `taskId`, when there is one, wins over another task with the same words, then one that isn't done. A name
// matches only with a quote on each side, so a task called "Call Mom" never matches inside "Call Mom back".
// Returns [{ text } | { text, task }], in order.
export function nudgeParts(message, tasks, taskId = null) {
  const text = message || "";
  const named = (tasks || []).filter(t => t.text && text.includes(`"${t.text}"`))
    .sort((a, b) => (b.id === taskId) - (a.id === taskId) || Number(!!a.done) - Number(!!b.done));
  const byText = new Map();
  named.forEach(t => { if (!byText.has(t.text)) byText.set(t.text, t); });
  if (!byText.size) return [{ text }];
  const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const pattern = new RegExp(`"(${[...byText.keys()].map(escape).join("|")})"`, "g");
  const parts = [];
  let at = 0;
  for (const m of text.matchAll(pattern)) {
    if (m.index > at) parts.push({ text: text.slice(at, m.index) });
    parts.push({ text: m[0], task: byText.get(m[1]) });
    at = m.index + m[0].length;
  }
  if (at < text.length) parts.push({ text: text.slice(at) });
  return parts;
}
